module.exports = __webpack_public_path__ + "h5/img/bs_12.1004a6d8.jpeg";